export const notFound = {
  tag: 'main',
  id: 'main-content',
  extends: 'AppPage',
  flow: 'y',
  metadata: { title: 'Not found / Symbols.app' },
  align: 'center center',
  height: '100%',
  width: '100%',
  padding: 'C',
  color: 'title',
  textAlign: 'center',
  gap: 'A',

  StatusCode: {
    tag: 'h1',
    text: (el, s) => String(s.root?.notFoundStatus || 404),
    fontSize: 'E',
    fontWeight: '700',
    letterSpacing: '-0.04em',
    margin: '0',
    color: 'title'
  },
  Title: {
    tag: 'h2',
    text: (el, s) => s.root?.notFoundTitle || 'Page not found',
    fontSize: 'B',
    fontWeight: '600',
    margin: '0',
    color: 'title'
  },
  Message: {
    tag: 'p',
    text: (el, s) =>
      s.root?.notFoundMessage ||
      "The page you're looking for doesn't exist. It may have been moved or the URL may be incorrect.",
    maxWidth: 'I',
    margin: '0 auto',
    color: 'caption',
    fontSize: 'Z1',
    lineHeight: '1.5em'
  },

  Actions: {
    flow: 'x',
    gap: 'Y',
    align: 'center',
    marginTop: 'A',

    // Shown only when the blocker is auth — the recovery is to sign in.
    SignIn: {
      extends: 'Button',
      if: (el, s) => s.root?.notFoundStatus === 401,
      text: 'Sign in',
      padding: 'Y A',
      round: 'Z',
      cursor: 'pointer',
      border: '0',
      background: 'brand',
      color: 'title',
      ':hover': { background: 'brand+10' },
      onClick: (e, el) => el.router('/signin', el.getRoot())
    },
    // Shown for any retryable error (5xx, 429, network) — reload re-runs
    // the bootstrap fetch without leaving the URL.
    Retry: {
      extends: 'Button',
      if: (el, s) => {
        const code = s.root?.notFoundStatus
        return code === 429 || (code >= 500 && code < 600)
      },
      text: 'Retry',
      padding: 'Y A',
      round: 'Z',
      cursor: 'pointer',
      border: '0',
      background: 'overlayStrong',
      color: 'title',
      ':hover': { background: 'overlay' },
      onClick: (e, el) => el.call('reloadPage')
    },

    Back: {
      extends: 'Link',
      href: '/dashboard',
      text: 'Back to dashboard',
      padding: 'Y A',
      round: 'Z',
      cursor: 'pointer',
      border: '0',
      background: 'overlayStrong',
      color: 'title',
      ':hover': { background: 'overlay' }
    }
  }
}
